import { Link } from "react-router-dom";
import { IKRA_LOGO, NAV_LINKS, INSTAGRAM_URL, CONTACT } from "@/data/content";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[var(--ikra-bg)] text-[var(--ikra-ink)] pt-20 pb-10 border-t border-[var(--ikra-line)]"
    >
      <div className="max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="inline-flex h-9 w-9 items-center justify-center overflow-hidden">
                <img src={IKRA_LOGO} alt="Ikra" className="h-9 w-9 object-contain" style={{ mixBlendMode: "screen" }} />
              </span>
              <span className="font-display font-medium text-base tracking-tight">
                IKRA Marketing & Sales
              </span>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.2em] text-[var(--ikra-muted)] mb-5">
              Nawigacja
            </div>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={`/${l.href}`}
                    className="ikra-link text-sm text-[var(--ikra-ink)]/80 hover:text-[var(--ikra-ink)]"
                    data-testid={`footer-link-${l.href.replace("#", "")}`}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="/#aplikuj"
                  className="ikra-link text-sm text-[var(--ikra-ink)]/80 hover:text-[var(--ikra-ink)]"
                  data-testid="footer-link-aplikuj"
                >
                  Aplikuj
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.2em] text-[var(--ikra-muted)] mb-5">
              Kontakt
            </div>
            <ul className="space-y-3 text-sm text-[var(--ikra-ink)]/85">
              <li className="flex items-start gap-3">
                <Mail size={16} className="mt-0.5 text-[var(--ikra-muted)]" />
                <a href={`mailto:${CONTACT.email}`} className="ikra-link" data-testid="footer-email">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={16} className="mt-0.5 text-[var(--ikra-muted)]" />
                <a href={CONTACT.phoneHref} className="ikra-link" data-testid="footer-phone">
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="mt-0.5 text-[var(--ikra-muted)]" />
                <span data-testid="footer-address">{CONTACT.address}</span>
              </li>
              <li className="flex items-start gap-3">
                <Instagram size={16} className="mt-0.5 text-[var(--ikra-muted)]" />
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ikra-link"
                  data-testid="footer-instagram"
                >
                  @ikra_bialystok
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-7 border-t border-[var(--ikra-line)] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-[var(--ikra-muted)]">
          <span>© {new Date().getFullYear()} IKRA Marketing & Sales. Wszystkie prawa zastrzeżone.</span>
          <div className="flex gap-6">
            <Link to="/polityka-prywatnosci" data-testid="footer-privacy-link" className="hover:text-[var(--ikra-ink)] transition-colors">
              Polityka prywatności
            </Link>
            <Link to="/regulamin" data-testid="footer-terms-link" className="hover:text-[var(--ikra-ink)] transition-colors">
              Regulamin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
